var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _accountsMap, _partialAccountsMap;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldGet(e, t) { var r = _classPrivateFieldGet2(t, e); return _classApplyDescriptorGet(e, r); }
function _classPrivateFieldGet2(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _classApplyDescriptorGet(e, t) { return t.get ? t.get.call(e) : t.value; }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { AccountService, ListAccountsRequest } from '@square/dashboard-protos/models/squareup/banking/account_service';
import { AccountType, OwnerType } from '@square/dashboard-protos/models/squareup/banking/common';
import Service, { inject as service } from '@ember/service';
import { computed, set, notifyPropertyChange } from '@ember/object';
import rpc from '@banking/api/utils/rpc';
export const LIST_ACCOUNTS_URL = '/api/v1/banking/list-accounts';
const MAX_LIST_ACCOUNTS_SIZE = 40;
let BankingAccountApi = (_dec = computed('accountsMap'), _dec2 = computed('partialAccountsMap'), _dec3 = computed('capitalEngineContext.headers'), _dec4 = computed('accounts'), _dec5 = computed('accounts'), _dec6 = computed('accounts'), _class = (_accountsMap = /*#__PURE__*/new WeakMap(), _partialAccountsMap = /*#__PURE__*/new WeakMap(), class BankingAccountApi extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor, this);
    _defineProperty(this, "currentListAccountsRequest", void 0);
    _defineProperty(this, "isLoading", false);
    _classPrivateFieldInitSpec(this, _accountsMap, {
      writable: true,
      value: new Map()
    });
    _classPrivateFieldInitSpec(this, _partialAccountsMap, {
      writable: true,
      value: new Map()
    });
  }
  get accounts() {
    return [..._classPrivateFieldGet(this, _accountsMap).values()].flat();
  }
  get partialAccounts() {
    return [..._classPrivateFieldGet(this, _partialAccountsMap).values()].flat();
  }
  getAccountsForOwner(owner) {
    return _classPrivateFieldGet(this, _accountsMap).get(owner.id) || [];
  }
  getPartialAccountsForOwner(owner) {
    return _classPrivateFieldGet(this, _partialAccountsMap).get(owner.id) || [];
  }
  getAccount(id) {
    return this.accounts.find(account => account.id === id);
  }
  get client() {
    return AccountService.create(rpc((method, guessedUrl) => {
      switch (method) {
        case AccountService.methods.ListAccounts:
          return LIST_ACCOUNTS_URL;
        default:
          return guessedUrl;
      }
    }, new Map(Object.entries(this.capitalEngineContext.headers))));
  }
  get checkingBalances() {
    return this.accounts.filter(account => {
      return account?.owner?.type === OwnerType.UNIT && account.type !== AccountType.SAVINGS_ACCOUNT && account.type !== AccountType.FOLDERS_ACCOUNT;
    });
  }
  get savingsBalances() {
    return this.accounts.filter(account => {
      return account?.owner?.type === OwnerType.MERCHANT && account.type === AccountType.SAVINGS_ACCOUNT;
    });
  }
  get folderBalances() {
    return this.accounts.filter(account => {
      return account?.owner?.type === OwnerType.MERCHANT && account.type === AccountType.FOLDERS_ACCOUNT;
    });
  }
  updateAccountsMaps(accounts, partialAccounts) {
    accounts.forEach(account => {
      if (account.owner) {
        const accountsForOwner = this.getAccountsForOwner(account.owner);
        const ownerAccountIds = accountsForOwner.map(accountForOwner => accountForOwner.id);

        // If we haven't fetched this account yet, add it to the map.
        // Otherwise, remove previously fetched account
        // and replace it with the fresh one.
        if (!ownerAccountIds.includes(account.id)) {
          accountsForOwner.push(account);
        } else {
          const accountIndex = ownerAccountIds.indexOf(account.id);
          accountsForOwner[accountIndex] = account;
        }
        _classPrivateFieldGet(this, _accountsMap).set(account.owner.id, accountsForOwner);
      }
    });
    partialAccounts.forEach(partialAccount => {
      if (partialAccount.owner) {
        const partialAccountsForOwner = _classPrivateFieldGet(this, _partialAccountsMap).get(partialAccount.owner.id);
        if (!partialAccountsForOwner) {
          _classPrivateFieldGet(this, _partialAccountsMap).set(partialAccount.owner.id, [partialAccount]);
        } else {
          const accountIndex = partialAccountsForOwner.findIndex(account => account.id === partialAccount.id);
          if (accountIndex === -1) {
            partialAccountsForOwner.push(partialAccount);
          } else {
            partialAccountsForOwner[accountIndex] = partialAccount;
          }
        }
      }
    });
    notifyPropertyChange(this, 'accountsMap');
    notifyPropertyChange(this, 'partialAccountsMap');
  }
  async fetchAccounts(owners, {
    toggleLoading = true
  } = {}) {
    if (owners.length === 0) {
      return;
    }
    const request = ListAccountsRequest.create({
      owners
    });
    this.currentListAccountsRequest = request;
    if (toggleLoading) {
      set(this, 'isLoading', true);
    }
    try {
      const {
        accounts,
        partialAccounts
      } = await this.client.listAccounts(request);
      this.updateAccountsMaps(accounts, partialAccounts);
    } finally {
      if (toggleLoading) {
        set(this, 'isLoading', false);
      }
    }
  }

  // Ledger's ListPendingBalances has a max size of 100 in the request.
  // 03-26-24: Seeing timeouts when fetching 100 accounts at once. The response
  // was taking ~9s. Reducing the max size to 40 to see if that helps.
  async listAccountsBatch(owners, size = MAX_LIST_ACCOUNTS_SIZE) {
    const ownersBatch = Array.from({
      length: Math.ceil(owners.length / size)
    }, (_element, i) => owners.slice(i * size, i * size + size));
    const accounts = await ownersBatch.reduce(async (prevPromise, owners) => {
      return [...(await prevPromise), ...(await this.listAccounts(owners))];
    }, Promise.resolve([]));
    return accounts;
  }
  async listAccounts(owners, {
    reload = false,
    toggleLoading = true
  } = {}) {
    let ownersToFetch;
    if (reload) {
      ownersToFetch = owners;
    } else {
      ownersToFetch = owners.filter(owner => {
        return !_classPrivateFieldGet(this, _accountsMap).has(owner.id);
      });
    }
    await this.fetchAccounts(ownersToFetch, {
      toggleLoading
    });
    let accounts = [];
    owners.forEach(owner => {
      const ownerAccounts = this.getAccountsForOwner(owner);
      accounts = [...accounts, ...ownerAccounts];
    });
    return accounts;
  }
  async reloadAccounts() {
    await this.fetchAccounts(this.currentListAccountsRequest.owners);
  }
  async retrieveAccount(accountId, owners) {
    // See if we've already fetched this account
    const existingAccount = this.getAccount(accountId);
    if (existingAccount) {
      return existingAccount;
    } else {
      await this.listAccounts(owners);
      const fetchedAccount = this.getAccount(accountId);
      if (fetchedAccount) {
        return fetchedAccount;
      } else {
        throw new Error(`Unable to retrieve account ${accountId}`);
      }
    }
  }
}), _descriptor = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "accounts", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "accounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "partialAccounts", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "partialAccounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "client", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "client"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "checkingBalances", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "checkingBalances"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "savingsBalances", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "savingsBalances"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "folderBalances", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "folderBalances"), _class.prototype), _class);
export { BankingAccountApi as default };